import { useNavigate } from 'react-router-dom';
import { Home, ArrowLeft, Search, FileQuestion } from 'lucide-react';
import JourneyLayout from '../../components/JourneyLayout';

function NotFound() {
  const navigate = useNavigate();

  return (
    <JourneyLayout showJourneySidebar={false}>
      <div className="flex items-center justify-center min-h-[70vh] py-12">
        <div className="w-full max-w-2xl mx-auto">
          <div className="text-center space-y-8">
            {/* Animated 404 with creative design */}
            <div className="relative">
              <div className="text-8xl sm:text-9xl font-black text-gray-100 select-none">
                404
              </div>
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="text-6xl sm:text-7xl font-bold bg-gradient-to-r from-theme via-theme2 to-theme bg-clip-text text-transparent">
                  404
                </div>
              </div>
            </div>

            {/* Icon and Title */}
            <div className="space-y-4">
              <div className="flex justify-center">
                <div className="relative">
                  <div className="absolute inset-0 bg-theme/20 rounded-full blur-2xl animate-pulse"></div>
                  <div className="relative bg-gradient-to-br from-theme/10 to-theme2/10 p-5 rounded-2xl border-2 border-theme/20">
                    <FileQuestion className="h-12 w-12 text-theme" />
                  </div>
                </div>
              </div>
              
              <div>
                <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3">
                  Oops! Page Not Found
              </h1>
                <p className="text-gray-600 text-base sm:text-lg max-w-md mx-auto leading-relaxed">
                  The page you're looking for seems to have wandered off. Don't worry, we'll help you get back on track!
              </p>
              </div>
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-4">
                <button
                  onClick={() => navigate('/')}
                className="group w-full sm:w-auto bg-gradient-to-r from-theme to-theme2 text-white px-8 py-3.5 rounded-xl font-semibold text-base hover:shadow-lg hover:shadow-theme/30 transition-all duration-300 flex items-center justify-center gap-2 transform hover:scale-105"
                >
                <Home className="h-5 w-5 group-hover:scale-110 transition-transform" />
                  <span>Go to Home</span>
                </button>
                
                <button
                  onClick={() => navigate(-1)}
                className="w-full sm:w-auto bg-white border-2 border-gray-300 text-gray-700 px-8 py-3.5 rounded-xl font-semibold text-base hover:border-theme hover:text-theme transition-all duration-300 flex items-center justify-center gap-2 transform hover:scale-105"
                >
                  <ArrowLeft className="h-5 w-5" />
                  <span>Go Back</span>
              </button>
            </div>

            {/* Helpful Links */}
            {/* <div className="pt-8 border-t border-gray-200">
              <p className="text-sm text-gray-500 mb-4">Quick Links:</p>
              <div className="flex flex-wrap justify-center gap-4">
                <button
                  onClick={() => navigate('/apply-now')}
                  className="text-theme  font-medium text-sm transition-colors flex items-center gap-1"
                >
                  <Search className="h-4 w-4" />
                  <span>Start Application</span>
                </button>
                <span className="text-gray-300">•</span>
                <button
                  onClick={() => navigate('/dashboard')}
                  className="text-theme  font-medium text-sm transition-colors"
                >
                  Dashboard
                </button>
                <span className="text-gray-300">•</span>
                <button
                  onClick={() => navigate('/contact')}
                  className="text-theme  font-medium text-sm transition-colors"
                >
                  Contact Us
                </button>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    </JourneyLayout>
  );
}

export default NotFound;
